module.exports = __webpack_public_path__ + "img/All Rounder Unlocked.0f142a6.png";